import React from 'react'
import type { ReactNode } from 'react'

interface AnswersListProps<T extends React.ElementType> {
  as?: T
  className?: string
  restProps?: React.ComponentProps<T>
}

export const AnswersListItem = <T extends React.ElementType = 'div'>({
  as,
  className,
  children,
  restProps,
}: React.PropsWithChildren<AnswersListProps<T>>): ReactNode => {
  const As = as || 'div'
  return (
    <li>
      <As
        className={`flex size-full items-start gap-1 rounded-md border border-dashed p-2 text-base text-THEME-primary ${className || ''}`}
        {...restProps}
      >
        {children}
      </As>
    </li>
  )
}
